module.exports = __webpack_public_path__ + "static/images/two.2W8oRZ0.svg";